import React from "react";
import { InfoCircleTwoTone } from "@ant-design/icons";
import classnames from "classnames";

import Tooltip, { TooltipComponentProps } from "components/ui/tooltip/Tooltip";

import css from "./InfoButton.module.scss";

type InfoButtonProps = {
  note: React.ReactNode;
  className?: string;
  tooltipMaxWidth?: TooltipComponentProps["contentMaxWidth"];
};

export type InfoItemProps = {
  label: string | JSX.Element;
} & InfoButtonProps;

export function InfoButton({ className, note, tooltipMaxWidth }: InfoButtonProps): JSX.Element {
  return (
    <Tooltip content={note} contentMaxWidth={tooltipMaxWidth}>
      <InfoCircleTwoTone
        className={classnames(css.infoIcon, className)}
        twoToneColor={css.lightBlue}
      />
    </Tooltip>
  );
}

export function InfoItem({ note, label, className }: InfoItemProps): JSX.Element {
  return (
    <div className={className}>
      <span className={css.label}>{label}</span>
      <InfoButton note={note} />
    </div>
  );
}
